import type { IconButtonProps } from '@mui/material';
import { PhoneBookIcon } from '@src/shared/ui/icons';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from './IconButton';

const PhoneBookIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    const { t } = useTranslation();
    const tooltipTitle = t('common.internal_phone_book', 'Internal phone book');

    return (
      <IconButton ref={ref} {...props} tooltipTitle={tooltipTitle}>
        <PhoneBookIcon color="inherit" />
      </IconButton>
    );
  },
);

PhoneBookIconButton.displayName = 'PhoneBookIconButton';
export default PhoneBookIconButton;
